import Fetch, { V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE, DEFAULT_POST_RESPONSE } from '@config/constanta';

export const getCity = () => {
  const resourceUrl = `${V1}users/me/city-code/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getOccupationPosition = () => {
  const resourceUrl = `${V1}edd/occupation`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getEconomySector = () => {
  const resourceUrl = `${V1}kyc-center/data/enums/type/ECONOMY_SECTOR`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const postEddChecking = (payload) => {
  const resourceUrl = `${V1}edd/checking`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postEconomySector = (payload) => {
  const resourceUrl = `${V1}edd/economy-sector`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postEddSubmit = (payload) => {
  const resourceUrl = `${V1}edd/submit`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postVerifyDukcapil = (payload) => {
  const resourceUrl = `${V1}dukcapil/verify`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};

export const postSubmitKyc = (payload) => {
  const resourceUrl = `${V1}kyc-center/submit/`;
  return Fetch.post(resourceUrl, payload, false, false)
    .then((resp) => resp)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, ...error };
    });
};

export const postRenewalData = (payload) => {
  const resourceUrl = `${V1}edd/renewal-data/submit`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });
};
